import axios from 'axios';
import { appConfig } from 'src/config';
// ----------------------------------------------------------------------
const axiosInstance = axios.create({
  baseURL: appConfig.baseUrl,
});
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  (error) => Promise.reject(error),
);
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || 'Something went wrong',
    ),
);
export default axiosInstance;
